<app-chart [title]="title" [tooltip]="tooltip">
    <canvas
        class="content"
        baseChart
        *ngIf="chartDatasets && !noData; else noDataMessage"
        [type]="'line'"
        [legend]="true"
        [datasets]="chartDatasets"
        [options]="chartOptions">
    </canvas>

    <ng-template #noDataMessage>
        <div class="no-data">
            <p>{{ "common.noData" | labelsProvider }}</p>
        </div>
    </ng-template>
</app-chart>
